export default __webpack_public_path__ + "maps-examples-fly-to-1200-9cefbda5d13f45511f0b9000ba099fed.webp";